goog.provide("shadow.js.shim.module$ol$source$WMTS");
goog.provide("module$shadow_js_shim_module$ol$source$WMTS");
shadow.js.shim.module$ol$source$WMTS = shadow.js.nativeProvides["ol/source/WMTS"] = shadow$bridge("ol/source/WMTS");
module$shadow_js_shim_module$ol$source$WMTS.default = shadow.js.shim.module$ol$source$WMTS;
